import { render, staticRenderFns } from "./TransportInsurance.vue?vue&type=template&id=5782a5c8&scoped=true"
import script from "./TransportInsurance.vue?vue&type=script&lang=js"
export * from "./TransportInsurance.vue?vue&type=script&lang=js"
import style0 from "./TransportInsurance.vue?vue&type=style&index=0&id=5782a5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5782a5c8",
  null
  
)

export default component.exports